import React from 'react';

import { ThemeProps, withTheme } from 'styled-components';

import useStoreTranslation from 'hooks/useStoreTranslation';

import { Container, Filter, FilterIcon, MapButton, ListIcon, MapIcon, MapLabel, FilterIconContainer } from './styles';

interface Props extends ThemeProps<any> {
  showMap: boolean;
  hasMap: boolean;
  onMapClick: () => void;
  onFilterClick: () => void;
}

const FloatingFilter = ({ showMap, hasMap, onMapClick, onFilterClick }: Props) => {
  const { t } = useStoreTranslation();

  return (
    <Container>
      <Filter>
        {hasMap && (
          <>
            <div onClick={onMapClick} data-testid="auto-list-filter-map">
              <MapButton isVisible={!showMap}>
                <MapIcon />
                <MapLabel>{t('hotelsList.viewMap')}</MapLabel>
              </MapButton>
              <MapButton isVisible={showMap}>
                <ListIcon />
                <MapLabel>{t('hotelsList.viewList')}</MapLabel>
              </MapButton>
            </div>
            <Filter.Divider />
          </>
        )}
        <div onClick={onFilterClick} data-testid="auto-list-filter-button">
          <FilterIconContainer>
            <FilterIcon />
          </FilterIconContainer>
          <Filter.Label>{t('flightsList.filter')}</Filter.Label>
        </div>
      </Filter>
    </Container>
  );
};

export default withTheme(FloatingFilter);
